import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import apiClient, { getCurrentUser } from "../services/api";
import { toYouTubeEmbedUrl } from "../utils/youtube";
import "./ProfilePage.css";

export default function ProfilePage() {
  const { userId } = useParams();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const me = getCurrentUser();

  useEffect(() => {
    setLoading(true);
    setError("");
    apiClient
      .get(`/posts/user/${userId}`)
      .then(({ data }) => setPosts(Array.isArray(data) ? data : []))
      .catch((err) => {
        const msg =
          err.response?.data?.message ||
          (err.response?.status === 401
            ? "Sesi habis. Silakan login ulang."
            : "Gagal memuat profil");
        setError(msg);
        setPosts([]);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  const displayName = useMemo(() => {
    if (posts[0]?.nama) return posts[0].nama;
    if (me && (me.id === userId || me._id === userId)) return me.nama || "Profil Saya";
    return "Profil Kreator";
  }, [posts, me, userId]);

  const canDownloadPortfolio =
    me && (me.id === userId || me._id === userId || me.role === "guru");

  return (
    <div className="profile-page">
      <header className="profile-page-header">
        <Link to="/" className="profile-back">
          ← Kembali ke Rumah
        </Link>
        <div className="profile-header-main">
          <img src="/logo/logo-upi.png" alt="Rumah CERDAS" className="profile-logo" />
          <div>
            <h1>{displayName}</h1>
            <p className="profile-header-sub">Galeri karya digital storytelling</p>
          </div>
        </div>
      </header>

      <main className="profile-page-body">
        {canDownloadPortfolio && (
          <button
            type="button"
            className="btn-primary profile-portfolio-btn"
            onClick={() => window.open(`/api/users/${userId}/portfolio.pdf`, "_blank")}
          >
            📄 Unduh Portfolio PDF
          </button>
        )}

        {loading && <p className="profile-status">Memuat karya...</p>}

        {!loading && error && <div className="profile-error">{error}</div>}

        {!loading && !error && posts.length === 0 && (
          <p className="profile-status">Belum ada karya yang dipublikasikan.</p>
        )}

        <div className="profile-posts">
          {posts.map((p) => (
            <article key={p._id} className="profile-post-card">
              <h2>{p.caption || "Tanpa caption"}</h2>
              {p.videoLink && (
                <div className="profile-video-wrap">
                  <iframe
                    width="100%"
                    height="220"
                    src={toYouTubeEmbedUrl(p.videoLink)}
                    title={p.caption || "Video"}
                    allowFullScreen
                  />
                </div>
              )}
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}
